module.exports = __webpack_public_path__ + "static/media/logo112.d9a5f473.png";